import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddMethod = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 7,
	viewBox: "0 0 15 7",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#4A5666",
			d: "M2.128 3.793a1 1 0 0 1-.19.182 5 5 0 0 1-.24.165l-1.185.69-.443-.75 1.193-.69q.134-.083.266-.135.13-.053.273-.075a.9.9 0 0 1-.273-.075 3 3 0 0 1-.266-.143L.07 2.266l.435-.75 1.193.705q.127.082.243.169.117.085.199.19a1 1 0 0 1-.071-.269 2 2 0 0 1-.019-.292V.63h.885v1.373q0 .158-.019.303a1 1 0 0 1-.07.274c.06-.075.122-.136.194-.191q.112-.087.248-.169l1.185-.69.442.75-1.192.683q-.136.082-.267.138a1.2 1.2 0 0 1-.273.079q.255.045.54.21l1.192.698-.435.75-1.193-.698a4 4 0 0 1-.247-.165 1.2 1.2 0 0 1-.203-.187q.099.24.098.555v1.38H2.05V4.35q0-.15.019-.292a1.3 1.3 0 0 1 .063-.27zM2.14 2.58l-.004-.01zm.705 0 .007-.008zM12.128 3.793a1 1 0 0 1-.19.182 5 5 0 0 1-.24.165l-1.186.69-.442-.75 1.192-.69q.136-.083.267-.135.13-.053.273-.075a.9.9 0 0 1-.273-.075 3 3 0 0 1-.267-.143l-1.192-.697.435-.75 1.192.705q.129.082.244.169.117.085.199.19a1 1 0 0 1-.071-.269 2 2 0 0 1-.019-.292V.63h.885v1.373q0 .158-.019.303a1 1 0 0 1-.07.274c.06-.075.122-.136.194-.191q.112-.087.248-.169l1.185-.69.442.75-1.192.683q-.136.082-.267.138a1.2 1.2 0 0 1-.274.079q.255.045.54.21l1.193.698-.435.75-1.193-.698a4 4 0 0 1-.247-.165 1.2 1.2 0 0 1-.202-.187q.097.24.097.555v1.38h-.885V4.35q0-.15.019-.292a1.3 1.3 0 0 1 .063-.27zm.012-1.213-.004-.01zm.705 0 .007-.008z"
		}), /* @__PURE__ */ _jsx("path", {
			stroke: "#4A5666",
			strokeLinecap: "square",
			d: "m8 .5-1 6"
		})]
	})
});
export default SvgAddMethod;
